var mods = require('./mods')
var axios = require("./lib/axios")
var MyPromise = require("./MyPromise")
var wxPay = require('./wxPay')
var aliPay = require('./aliPay')
var utils = require('./utils')

axios.defaults.timeout = 60000;
axios.defaults.headers = {
    "Content-Type": "application/json",
    "Accept": "application/json"
};

module.exports = {
    /**
     *  发起支付并监听支付返回结果
     * @param payment  支付数据
     * @param timeout 结果监听超时时间，默认 120s
     * @param payCallback 支付结果回调 返回结果对象
     */
    doPay: function (payment, timeout, payCallback) {
        let result = {}
        // 校验payment 必填：pay_channel，pay_amt 非必填：goods_title，goods_desc
        let check = this.checkpayment(payment)
        if (check) {
            mods.payResult.paramError.result_message = check
            payCallback(mods.payResult.paramError)
            return
        }
        // 二维码主扫
        if (payment.pay_channel === mods.channelConfig.alipay_qr || payment.pay_channel === mods.channelConfig.wx_qr) {
            this.handlePayResult(payment.query_url, timeout).then(function (res) {
                payCallback(res)
            })
        }else if (payment.pay_channel === mods.channelConfig.alipay_wap || payment.pay_channel === mods.channelConfig.alipay_lite){ // 支付宝 
            this.aliPay(payment, timeout, function (pay_result) {
                payCallback(pay_result)
            })
        }else if (payment.pay_channel === mods.channelConfig.wx_pub){ // 微信H5
            this.wxPay(payment, timeout, function (pay_result) {
                payCallback(pay_result)
            })
        }else{
            mods.payResult.paramError.result_message = mods.chackMsg.channelError

            payCallback(mods.payResult.paramError)
        }
    },

    /**
     *  发起主动查询支付返回结果
     * @param payment  支付数据
     * @param payCallback 支付结果回调 返回结果对象
     */
    query: function (payment, payCallback) {
        // 请求轮询接口
        this.requestPayResult(payment.query_url).then(function (res) {
            payCallback(res)
        })
    },

    /**
     *  支付宝操作
     * @param payment 支付信息
     * @param timeout 支付查询结果
     * @param aliPayCallback 支付宝支付结果回调
     */
    aliPay: function (payment, timeout, aliPayCallback) {
        aliPay.wapFunc(payment)
        this.handlePayResult(payment.query_url, timeout).then(function (res) {
            aliPayCallback(res)
        })
        // if (utils.app === 'alipay') {
        //     let pay_info = JSON.parse(payment.expend.pay_info)
        //     let tradeNO = pay_info.tradeNO
            
        //     aliPay.liteFunc(tradeNO, function (result) {
        //         if (result.resultCode === '9000') {
        //             this.handlePayResult(payment.query_url, timeout).then(function (res) {
        //                 aliPayCallback(res)
        //             })
        //         }else{
        //             aliPayCallback(mods.payResult.failed)
        //         }
        //     })
        // }else{
        //     aliPay.wapFunc(payment)
        //     this.handlePayResult(payment.query_url, timeout).then(function (res) {
        //         aliPayCallback(res)
        //     })
        // }
    },

    /**
     *  微信支付操作
     * @param payment 支付信息
     * @param timeout 支付查询结果
     * @param wxPayCallback 微信支付结果回调
     */
    wxPay: function (payment, timeout, wxPayCallback) {
        if (payment.prod_mode === "false") {
            let url = payment.expend.pay_info + "?payment_id=" + payment.id + "&pay_channel=" + payment.pay_channel

            utils.os.isPc ? window.open(url) : window.location.href = url

            this.handlePayResult(payment.query_url, timeout).then(function (res) {
                wxPayCallback(res)
            })
        }else{
            let self = this
            // 微信 sdk 
            let pay_info = JSON.parse(payment.expend.pay_info)
            wxPay.wxPay(pay_info, function (status) {
                if (status === mods.payStatus.cancel) {
                    wxPayCallback(mods.payResult.cancel)
                }else if (status === mods.payStatus.failed) {
                    wxPayCallback(mods.payResult.failed)
                }else{
                    self.handlePayResult(payment.query_url, timeout).then(function (res) {
                        wxPayCallback(res)
                    })
                }
            })
        }
    },

    /**
     *  轮询支付结果 返回 Promise
     * @param query_url 轮询 url
     * @param timeout 轮询超时时间
     */
    handlePayResult: function (query_url, timeout) {
        var idx = 0
        let self = this
        // 定时器id
        var intervalID = undefined
        let result_info = {}

        return new MyPromise(function (resolve, reject) {
            intervalID = setInterval(function () {
                // 如果轮询时间结束 取消定时器并返回支付超时状态
                if (idx > timeout) {
                    clearInterval(intervalID)

                    mods.payResult.timeout.result_info = result_info
                    resolve(mods.payResult.timeout)
                }
                idx = idx + 1;
                // 请求轮询接口
                self.requestPayResult(query_url).then(function (res) {
                    result_info = res.result_info

                    // 如果是支付成功或失败都结束查询 否则继续轮询
                    if (res.result_status === mods.payStatus.succeeded || res.result_status === mods.payStatus.failed) { 
                        clearInterval(intervalID)
                        resolve(res)
                    }
                })
            }, 3000)
        })
    },

    /**
     *  轮询支付结果的网络请求
     */
    requestPayResult: function (query_url) {
        return new MyPromise(function (resolve, reject) {
            
            axios.get(query_url).then(function (response) {
                let data = response.data
                // 支付成功
                if (data.status === mods.payStatus.succeeded) { 
                    
                    mods.payResult.succeeded.result_info = data
                    resolve(mods.payResult.succeeded)
                }else if (data.status === mods.payStatus.pending) { // 支付中
                    mods.payResult.pending.result_info = data
                    resolve(mods.payResult.pending)
                }else{
                    // 由于支付失败或者支付中等状态都是由 restful 风格，包在error中顾直接返回 unknown
                    mods.payResult.unknown.result_info = data
                    resolve(mods.payResult.unknown)
                }
            }).catch(function (error) {
                // error.response 中包含除支付成功的信息
                if (error && error.response) {
                    let data = error.response.data

                    mods.payResult.failed.result_info = data
                    resolve(mods.payResult.failed)
                }else{ // unknown 其他状态
                    mods.payResult.unknown.result_info = {}
                    resolve(mods.payResult.unknown)
                }
            });
        })
    },

    /**
     *  支付数据的校验
     */
    checkpayment: function (params) {
        let channelArr = Object.values(mods.channelConfig)
        
        if (params.status !== "succeeded") {
            return mods.chackMsg.orderError
        }
        // 验证传入的支付渠道是否正确
        if (channelArr.indexOf(params.pay_channel) < 0) { 
            return mods.chackMsg.channelError
        }
        
        return undefined
    },
}


// WEBPACK FOOTER //
// ./src/payTool.js